/* eslint-disable import/prefer-default-export */
import React from 'react';

const PhoneAT = (props) => (
  <svg viewBox="0 0 318.6 656.2" {...props}>
    <title>NutriGuide interface example presented on a phone</title>
    <path
      d="M46.4 0h225.8c25.6 0 46.4 20.8 46.4 46.4v563.5c0 25.6-20.8 46.4-46.4 46.4H46.4C20.8 656.2 0 635.4 0 609.8V46.4C0 20.8 20.8 0 46.4 0z"
      fill="#ebebeb"
    />
    <defs>
      <path
        id="prefix__a"
        d="M46.4 0h225.8c25.6 0 46.4 20.8 46.4 46.4v563.5c0 25.6-20.8 46.4-46.4 46.4H46.4C20.8 656.2 0 635.4 0 609.8V46.4C0 20.8 20.8 0 46.4 0z"
      />
    </defs>
    <clipPath id="prefix__b">
      <use xlinkHref="#prefix__a" overflow="visible" />
    </clipPath>
    <g clipPath="url(#prefix__b)">
      <path fill="#ebebeb" d="M-61.8-61.8h442.2V718H-61.8z" />
      <defs>
        <path id="prefix__c" d="M-61.8-61.8h442.2V718H-61.8z" />
      </defs>
      <clipPath id="prefix__d">
        <use xlinkHref="#prefix__c" overflow="visible" />
      </clipPath>
      <g clipPath="url(#prefix__d)">
        <path fill="#ebebeb" d="M-1.3-1.3h321.1v658.8H-1.3z" />
      </g>
    </g>
    <path
      d="M45.3 14.4h227.9c17.1 0 30.9 13.8 30.9 30.9v565.5c0 17.1-13.8 30.9-30.9 30.9H45.3c-17.1 0-30.9-13.8-30.9-30.9V45.3c0-17 13.9-30.9 30.9-30.9z"
      fill="#fff"
    />
    <defs>
      <path
        id="prefix__e"
        d="M45.3 14.4h227.9c17.1 0 30.9 13.8 30.9 30.9v565.5c0 17.1-13.8 30.9-30.9 30.9H45.3c-17.1 0-30.9-13.8-30.9-30.9V45.3c0-17 13.9-30.9 30.9-30.9z"
      />
    </defs>
    <clipPath id="prefix__f">
      <use xlinkHref="#prefix__e" overflow="visible" />
    </clipPath>
    <g clipPath="url(#prefix__f)">
      <path fill="#fff" d="M-61.8-61.8h442.2V718H-61.8z" />
      <defs>
        <path id="prefix__g" d="M-61.8-61.8h442.2V718H-61.8z" />
      </defs>
      <clipPath id="prefix__h">
        <use xlinkHref="#prefix__g" overflow="visible" />
      </clipPath>
      <g clipPath="url(#prefix__h)">
        <path fill="#fff" d="M13.1 13.1h292.3V643H13.1z" />
        <defs>
          <path id="prefix__i" d="M13.1 13.1h292.3V643H13.1z" />
        </defs>
        <clipPath id="prefix__j">
          <use xlinkHref="#prefix__i" overflow="visible" />
        </clipPath>
        <g clipPath="url(#prefix__j)">
          <path fill="#fff" d="M14.4 14.4h289.7v627.3H14.4z" />
          <defs>
            <path id="prefix__k" d="M14.4 14.4h289.7v627.3H14.4z" />
          </defs>
          <clipPath id="prefix__l">
            <use xlinkHref="#prefix__k" overflow="visible" />
          </clipPath>
          <g clipPath="url(#prefix__l)">
            <path fill="#fff" d="M13.1 13.1h292.3V643H13.1z" />
          </g>
        </g>
      </g>
    </g>
    <path
      d="M81.4 13.9h156.1V19c0 9.7-7.8 17.5-17.5 17.5H99c-9.7 0-17.5-7.8-17.5-17.5l-.1-5.1z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="#ebebeb"
    />
    <defs>
      <path
        id="prefix__m"
        d="M81.4 13.9h156.1V19c0 9.7-7.8 17.5-17.5 17.5H99c-9.7 0-17.5-7.8-17.5-17.5l-.1-5.1z"
      />
    </defs>
    <clipPath id="prefix__n">
      <use xlinkHref="#prefix__m" overflow="visible" />
    </clipPath>
    <g clipPath="url(#prefix__n)">
      <path fill="#ebebeb" d="M-61.8-61.8h442.2V718H-61.8z" />
      <defs>
        <path id="prefix__o" d="M-61.8-61.8h442.2V718H-61.8z" />
      </defs>
      <clipPath id="prefix__p">
        <use xlinkHref="#prefix__o" overflow="visible" />
      </clipPath>
      <g clipPath="url(#prefix__p)">
        <path fill="#ebebeb" d="M80.1 12.6h158.6v25.2H80.1z" />
      </g>
    </g>
    <defs>
      <path id="prefix__q" d="M24.4 44.1h270v57.7h-270z" />
    </defs>
    <clipPath id="prefix__r">
      <use xlinkHref="#prefix__q" overflow="visible" />
    </clipPath>
    <g clipPath="url(#prefix__r)">
      <text
        transform="translate(70.24 99.62)"
        fill="#71bf44"
        fontFamily="Roboto-Regular"
        fontSize={9}
      >
        {'FELD'}
      </text>
    </g>
    <defs>
      <path id="prefix__s" d="M61.9 47.9h37.5v37.5H61.9z" />
    </defs>
    <clipPath id="prefix__t">
      <use xlinkHref="#prefix__s" overflow="visible" />
    </clipPath>
    <g clipPath="url(#prefix__t)">
      <path
        d="M98.9 66.6c0 .6 0 1.2-.1 1.8-.1.6-.1 1.2-.3 1.8-.1.6-.3 1.2-.4 1.7-.2.6-.4 1.1-.6 1.7s-.5 1.1-.8 1.6c-.6 1.1-1.2 2.1-2 3-.4.5-.8.9-1.2 1.3s-.9.8-1.3 1.2c-.5.4-.9.7-1.4 1.1l-1.5.9c-.5.3-1.1.5-1.6.8s-1.1.4-1.7.6-1.1.3-1.7.4l-1.8.3c-.6.1-1.2.1-1.8.1-.6 0-1.2 0-1.8-.1-.6-.1-1.2-.1-1.8-.3-.6-.1-1.2-.3-1.7-.5-.6-.2-1.1-.4-1.7-.6s-1.1-.5-1.6-.8l-1.5-.9c-.5-.3-1-.7-1.4-1.1s-.9-.8-1.3-1.2c-.4-.4-.8-.9-1.2-1.3-.8-.9-1.4-1.9-2-3-.3-.5-.5-1.1-.8-1.6-.2-.5-.4-1.1-.6-1.7-.2-.6-.3-1.1-.4-1.7l-.3-1.8c-.1-.6-.1-1.2-.1-1.8 0-.6 0-1.2.1-1.8l.3-1.8c.1-.6.3-1.2.4-1.7.2-.6.4-1.1.6-1.7.2-.5.5-1.1.8-1.6.6-1.1 1.2-2.1 2-3 .4-.5.8-.9 1.2-1.3.4-.4.9-.8 1.3-1.2.5-.4.9-.7 1.4-1.1s1-.6 1.5-.9 1.1-.5 1.6-.7 1.1-.4 1.7-.6c.6-.2 1.2-.3 1.7-.4s1.2-.2 1.8-.3c.6-.1 1.2-.1 1.8-.1.6 0 1.2 0 1.8.1l1.8.3c.6.1 1.2.3 1.7.4.6.2 1.1.4 1.7.6.6.2 1.1.5 1.6.8l1.5.9c1 .7 1.9 1.4 2.8 2.3.4.4.8.9 1.2 1.3.8.9 1.4 1.9 2 3 .3.5.5 1.1.8 1.6s.4 1.1.6 1.7c.2.6.3 1.2.4 1.7l.3 1.8v1.8z"
        fill="none"
        stroke="#71bf44"
        strokeWidth={1.09}
        strokeMiterlimit={10}
      />
      <path
        d="M93.3 63.5l-6.1 7.6-5.6-4.3 5.4-5.6 6.3 2.3zm1.3-.3c0-.2-.2-.3-.3-.3L87 60.2c-.2-.1-.4 0-.5.1l-6 6.2c-.1.1-.1.2-.1.4 0 .1.1.3.2.4l6.4 4.9c.1.1.2.1.3.1.2 0 .3-.1.4-.2l6.8-8.6c.1 0 .2-.2.1-.3zM85.7 73l-1.5 1.7-6.7-3.6 2.4-2.4 5.8 4.3zm-5.6-5.4c-.2-.2-.5-.1-.7.1l-3.2 3.2c-.1.1-.2.3-.2.4 0 .2.1.3.3.4l7.7 4.1c.1 0 .2.1.2.1.1 0 .3-.1.4-.2l2.1-2.3c.1-.1.1-.2.1-.4 0-.1-.1-.3-.2-.4l-6.5-5zm4.5-7.3l-9.4 9.4-7-3.7 11.1-7.5 5.3 1.8zm1.5-.3c0-.2-.2-.3-.3-.4l-6.4-2.1c-.2 0-.3 0-.5.1l-12 8.1-.2.2v.2c0 .1 0 .2.1.2 0 .1.1.1.2.2l8.1 4.3c.1 0 .2.1.2.1.1 0 .3-.1.4-.2l10.2-10.3c.2-.1.2-.2.2-.4z"
        fill="#71bf44"
      />
    </g>
    <defs>
      <path id="prefix__u" d="M24.4 68.1h37.5v.8H24.4z" />
    </defs>
    <clipPath id="prefix__v">
      <use xlinkHref="#prefix__u" overflow="visible" />
    </clipPath>
    <g clipPath="url(#prefix__v)">
      <path
        d="M59.7 68.1h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.3m-3.7-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.3m-3.6-.8h2.2v.8h-2.2m-3.8-.8H43v.8h-2.2m-3.8-.8h2.2v.8H37m-3.8-.8h2.2v.8h-2.2m-3.7-.8h2.3v.8h-2.3m-3.8-.8H28v.8h-2.2m-3.9-.8h2.2v.8h-2.3m-3.7-.8h2.2v.8h-2.2m-3.7-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.3m-3.7-.8H9v.8H6.8M3 68.1h2.2v.8H3m-3.7-.8h2.2v.8H-.7m-3.8-.8h2.2v.8h-2.2m-3.8-.8H-6v.8h-2.2m-3.9-.8h2.2v.8h-2.2m-3.7-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.7-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.7-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.7-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.7-.8h2.2v.8h-2.2m-3.8-.8h2.3v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.7-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.7-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.7-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.7-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2"
        fill="#71bf44"
      />
    </g>
    <defs>
      <path id="prefix__w" d="M24.4 44.1h270v57.7h-270z" />
    </defs>
    <clipPath id="prefix__x">
      <use xlinkHref="#prefix__w" overflow="visible" />
    </clipPath>
    <g clipPath="url(#prefix__x)" fill="#71bf44" fontFamily="Roboto-Regular" fontSize={9}>
      <text transform="translate(117.22 99.62)">KUL</text>
      <text transform="translate(132.33 99.62)">TUR</text>
    </g>
    <defs>
      <path id="prefix__y" d="M114.4 47.9h37.5v37.5h-37.5z" />
    </defs>
    <clipPath id="prefix__z">
      <use xlinkHref="#prefix__y" overflow="visible" />
    </clipPath>
    <g clipPath="url(#prefix__z)">
      <path
        d="M151.4 66.6c0 .6 0 1.2-.1 1.8-.1.6-.1 1.2-.3 1.8-.1.6-.3 1.2-.4 1.7-.2.6-.4 1.1-.6 1.7-.2.6-.5 1.1-.8 1.6-.6 1.1-1.2 2.1-2 3-.4.5-.8.9-1.2 1.3s-.9.8-1.3 1.2c-.5.4-.9.7-1.4 1.1l-1.5.9c-.5.3-1.1.5-1.6.8s-1.1.4-1.7.6c-.6.2-1.1.3-1.7.4l-1.8.3c-.6.1-1.2.1-1.8.1s-1.2 0-1.8-.1-1.2-.1-1.8-.3c-.6-.1-1.2-.3-1.7-.4-.6-.2-1.1-.4-1.7-.6s-1.1-.5-1.6-.8l-1.5-.9c-.5-.3-1-.7-1.4-1.1s-.9-.8-1.3-1.2c-.4-.4-.8-.9-1.2-1.3-.8-.9-1.4-1.9-2-3-.3-.5-.5-1.1-.8-1.6-.2-.5-.4-1.1-.6-1.7s-.3-1.1-.4-1.7l-.3-1.8c-.1-.6-.1-1.2-.1-1.8 0-.6 0-1.2.1-1.8l.3-1.8c.1-.6.3-1.2.4-1.7.2-.6.4-1.1.6-1.7.2-.5.5-1.1.8-1.6.6-1.1 1.2-2.1 2-3 .4-.5.8-.9 1.2-1.3.4-.4.9-.8 1.3-1.2.5-.4.9-.7 1.4-1.1s1-.6 1.5-.9 1.1-.5 1.6-.8c.5-.2 1.1-.4 1.7-.6.6-.2 1.2-.3 1.7-.4s1.2-.2 1.8-.3 1.2-.1 1.8-.1 1.2 0 1.8.1l1.8.3c.6.1 1.2.3 1.7.4.6.2 1.1.4 1.7.6.6.2 1.1.5 1.6.8l1.5.9c1 .7 1.9 1.4 2.8 2.3.4.4.8.9 1.2 1.3.8.9 1.4 1.9 2 3 .3.5.5 1.1.8 1.6s.4 1.1.6 1.7c.2.6.3 1.2.4 1.7l.3 1.8c-.1.6 0 1.2 0 1.8z"
        fill="#71bf44"
      />
      <path
        d="M151.4 66.6c0 .6 0 1.2-.1 1.8-.1.6-.1 1.2-.3 1.8-.1.6-.3 1.2-.4 1.7-.2.6-.4 1.1-.6 1.7-.2.6-.5 1.1-.8 1.6-.6 1.1-1.2 2.1-2 3-.4.5-.8.9-1.2 1.3s-.9.8-1.3 1.2c-.5.4-.9.7-1.4 1.1l-1.5.9c-.5.3-1.1.5-1.6.8s-1.1.4-1.7.6c-.6.2-1.1.3-1.7.4l-1.8.3c-.6.1-1.2.1-1.8.1s-1.2 0-1.8-.1-1.2-.1-1.8-.3c-.6-.1-1.2-.3-1.7-.4-.6-.2-1.1-.4-1.7-.6s-1.1-.5-1.6-.8l-1.5-.9c-.5-.3-1-.7-1.4-1.1s-.9-.8-1.3-1.2c-.4-.4-.8-.9-1.2-1.3-.8-.9-1.4-1.9-2-3-.3-.5-.5-1.1-.8-1.6-.2-.5-.4-1.1-.6-1.7s-.3-1.1-.4-1.7l-.3-1.8c-.1-.6-.1-1.2-.1-1.8 0-.6 0-1.2.1-1.8l.3-1.8c.1-.6.3-1.2.4-1.7.2-.6.4-1.1.6-1.7.2-.5.5-1.1.8-1.6.6-1.1 1.2-2.1 2-3 .4-.5.8-.9 1.2-1.3.4-.4.9-.8 1.3-1.2.5-.4.9-.7 1.4-1.1s1-.6 1.5-.9 1.1-.5 1.6-.8c.5-.2 1.1-.4 1.7-.6.6-.2 1.2-.3 1.7-.4s1.2-.2 1.8-.3 1.2-.1 1.8-.1 1.2 0 1.8.1l1.8.3c.6.1 1.2.3 1.7.4.6.2 1.1.4 1.7.6.6.2 1.1.5 1.6.8l1.5.9c1 .7 1.9 1.4 2.8 2.3.4.4.8.9 1.2 1.3.8.9 1.4 1.9 2 3 .3.5.5 1.1.8 1.6s.4 1.1.6 1.7c.2.6.3 1.2.4 1.7l.3 1.8c-.1.6 0 1.2 0 1.8z"
        fill="none"
        stroke="#71bf44"
        strokeWidth={1.09}
        strokeMiterlimit={10}
      />
      <path
        d="M130.4 70.1c0 1.2 1 2.3 2.2 2.3 0-.3-.1-.6-.2-.9-.1-.3-.3-.5-.5-.7s-.5-.4-.7-.5c-.2-.1-.5-.2-.8-.2zm3.3 2.3c.3 0 .6-.1.9-.2.3-.1.5-.3.7-.5s.4-.5.5-.7c.1-.3.2-.6.2-.9-1.5.2-2.4 1.1-2.3 2.3zm-.5-1.8c.2-.2.3-.4.5-.5.7-.6 1.5-.9 2.4-1 .2 0 .3-.1.4-.2l.3-.3c.2-.2.5-.2.7 0 .1.1.2.2.1.3 0 .1-.1.3-.1.3-.4.3-.6.8-.6 1.2-.1.7-.4 1.4-.9 1.9-.5.6-1.3 1-2.1 1h-.1v4.3c0 .2-.2.3-.4.3s-.4-.1-.4-.3v-4.3c-.2 0-.5 0-.7-.1-.5-.1-.9-.3-1.3-.6s-.6-.7-.8-1.2-.4-1-.5-1.5c0-.2-.1-.4-.3-.5l-.3-.3c-.1-.1-.2-.2-.1-.4 0-.1.1-.3.1-.4.1-.1.2-.1.4-.1.1 0 .2.1.3.2.3.3.6.5 1 .6.8.2 1.7.8 2.4 1.6zm-.5-6.3c0-1.2-.9-2.2-2.2-2.3.1 1.4 1 2.4 2.2 2.3zm1 0c1.1.1 2.1-.9 2.2-2.3-1.3.2-2.3 1-2.2 2.3zm-.5-6.9c-.8 1.1-.9 2.5 0 3.2.9-.8.8-2 0-3.2zm.5-1.3c0 .2 0 .5.2.6.6.8.9 1.7.9 2.7s-.5 1.8-1.3 2.4c-.1.1-.2.1-.3.1s-.2-.1-.3-.1c-.3-.2-.5-.4-.7-.7s-.3-.6-.4-.9c-.1-.3-.1-.7-.1-1s.1-.7.2-1c.2-.6.4-1.1.8-1.5.1-.1.1-.3.1-.4v-.5c0-.1 0-.3.1-.4.1-.1.2-.2.4-.2.1 0 .3.1.4.2.1.1.1.2.1.4l-.1.3zm-3.2 9.9c-.1 1.2 1.2 2.5 2.2 2.3.1-1.1-.8-2-2.2-2.3zm5.4 0c-1.4.2-2.4 1.3-2.2 2.3 1.1.1 2-.8 2.2-2.3zm-2.7.6c.6-.8 1.5-1.4 2.5-1.5.4 0 .8-.2 1-.5.1-.1.2-.1.2-.2.2-.1.4 0 .5.2.1.1.2.4.1.5 0 0 0 .1-.1.1-.4.3-.6.8-.6 1.2-.1.6-.4 1.2-.7 1.7-.5.7-1.3 1.2-2.2 1.2h-1.5c-.5 0-1-.2-1.4-.5s-.8-.7-1-1.1c-.3-.5-.5-1.1-.6-1.8 0-.2-.1-.4-.2-.5l-.3-.3c-.1-.1-.1-.2-.1-.3 0-.1.1-.2.2-.3.1-.1.2-.1.3-.1s.2.1.3.2c.3.3.7.5 1.1.6 1 0 1.9.6 2.5 1.4zm0-4.1c.3-.4.8-.8 1.3-1.1s1-.4 1.6-.4c.2 0 .3-.1.4-.2.1-.1.2-.3.2-.4v-4.5-.3c0-.2.2-.3.4-.3s.4.1.4.3V60.5c0 .3-.1.6-.3.8s-.4.4-.4.7c-.1.7-.4 1.4-.8 2-.3.4-.7.8-1.2 1-.5.2-1 .3-1.5.2h-.8c-1.2 0-2.2-.7-2.6-1.8-.2-.5-.4-1-.5-1.6 0-.2-.1-.4-.3-.5-.3-.2-.4-.6-.4-.9v-4.7c0-.1 0-.3.1-.4.1-.1.2-.2.4-.2.1 0 .3.1.4.2.1.1.1.2.1.4v4.6c0 .1.1.3.2.4.1.1.2.2.4.2.9 0 1.7.4 2.4.9.1.3.3.5.5.7z"
        fill="#fff"
      />
    </g>
    <g>
      <defs>
        <path id="prefix__A" d="M99.4 68.1h15v.8h-15z" />
      </defs>
      <clipPath id="prefix__B">
        <use xlinkHref="#prefix__A" overflow="visible" />
      </clipPath>
      <g clipPath="url(#prefix__B)">
        <path
          d="M112.2 68.1h2.2v.8h-2.2m-4.3-.8h2.2v.8h-2.2m-4.2-.8h2.2v.8h-2.2m-4.2-.8h2.2v.8h-2.3"
          fill="#839ca9"
        />
      </g>
    </g>
    <g>
      <defs>
        <path id="prefix__C" d="M24.4 44.1h270v57.7h-270z" />
      </defs>
      <clipPath id="prefix__D">
        <use xlinkHref="#prefix__C" overflow="visible" />
      </clipPath>
      <g clipPath="url(#prefix__D)">
        <text
          transform="translate(157.61 99.62)"
          fill="#839ca9"
          fontFamily="Roboto-Regular"
          fontSize={9}
        >
          {'ANWENDUNG'}
        </text>
      </g>
    </g>
    <g>
      <defs>
        <path id="prefix__E" d="M166.9 47.9h37.5v37.5h-37.5z" />
      </defs>
      <clipPath id="prefix__F">
        <use xlinkHref="#prefix__E" overflow="visible" />
      </clipPath>
      <g clipPath="url(#prefix__F)">
        <path
          d="M203.9 66.6c0 .6 0 1.2-.1 1.8-.1.6-.1 1.2-.3 1.8-.1.6-.3 1.2-.4 1.7-.2.6-.4 1.1-.6 1.7-.2.6-.5 1.1-.8 1.6-.6 1.1-1.2 2.1-2 3-.4.5-.8.9-1.2 1.3s-.9.8-1.3 1.2c-.5.4-.9.7-1.4 1.1l-1.5.9c-.5.3-1.1.5-1.6.8s-1.1.4-1.7.6c-.6.2-1.1.3-1.7.4l-1.8.3c-.6.1-1.2.1-1.8.1s-1.2 0-1.8-.1-1.2-.1-1.8-.3c-.6-.1-1.2-.3-1.7-.4-.6-.2-1.1-.4-1.7-.6s-1.1-.5-1.6-.8l-1.5-.9c-.5-.3-1-.7-1.4-1.1s-.9-.8-1.3-1.2c-.4-.4-.8-.9-1.2-1.3-.8-.9-1.4-1.9-2-3-.3-.5-.5-1.1-.8-1.6-.2-.5-.4-1.1-.6-1.7-.2-.6-.3-1.1-.4-1.7l-.3-1.8c-.1-.6-.1-1.2-.1-1.8 0-.6 0-1.2.1-1.8.1-.6.1-1.2.3-1.8.1-.6.3-1.2.4-1.7.2-.6.4-1.1.6-1.7.2-.5.5-1.1.8-1.6.6-1.1 1.2-2.1 2-3 .4-.5.8-.9 1.2-1.3.4-.4.9-.8 1.3-1.2.5-.4.9-.7 1.4-1.1s1-.6 1.5-.9 1.1-.5 1.6-.8c.5-.2 1.1-.4 1.7-.6.6-.2 1.1-.3 1.7-.4l1.8-.3c.6-.1 1.2-.1 1.8-.1s1.2 0 1.8.1l1.8.3c.6.1 1.2.3 1.7.4.6.2 1.1.4 1.7.6.6.2 1.1.5 1.6.8l1.5.9c1 .7 1.9 1.4 2.8 2.3.4.4.8.9 1.2 1.3.8.9 1.4 1.9 2 3 .3.5.5 1.1.8 1.6s.4 1.1.6 1.7c.2.6.3 1.2.4 1.7l.3 1.8c-.1.6 0 1.2 0 1.8z"
          fill="none"
          stroke="#839ca9"
          strokeWidth={1.09}
          strokeMiterlimit={10}
        />
        <path
          d="M182.8 63.2c.7 0 1.3.2 1.8.6.5.5.7 1.1.7 1.8-.7 0-1.3-.2-1.8-.6-.4-.5-.7-1.2-.7-1.8zm4.1.7c.5-.5 1.1-.7 1.8-.7 0 .7-.2 1.3-.6 1.8-.5.4-1.1.7-1.8.7 0-.7.2-1.3.6-1.8zm2.7 7h-3.3v-4.3c.9 0 1.8-.4 2.5-1 .7-.8 1-1.9.9-3 0-.1 0-.2-.1-.3s-.2-.1-.3-.1c-1.1-.1-2.1.3-2.9 1-.2.2-.3.4-.4.6-.1-.3-.3-.5-.5-.7-.8-.7-1.9-1-2.9-.9-.1 0-.2 0-.3.1s-.1.2-.1.3c-.1 1.1.3 2.1 1 2.9.7.6 1.6.9 2.5.9v4.3h-3.8c-.1 0-.3 0-.3.1-.1.1-.1.2-.1.3 0 .1 0 .3.1.4s.1.1.2.1h8c.1 0 .3 0 .3-.1.1-.1.1-.2.1-.3 0-.1 0-.3-.1-.3-.3 0-.4-.1-.5 0zm3.5-9.4V78h-14.9V61.4c0-.4.1-.9.3-1.3l1.3-2.9h11.6l1.3 2.9c.3.4.4.9.4 1.4zm-13.2-5.2v-1h11.4v1h-11.4zm13.7 3.5l-1.4-3.1v-1.9c0-.1-.1-.2-.1-.3-.1-.1-.2-.1-.3-.2h-12.3c-.2 0-.4.2-.5.4v1.9l-1.3 3.1c-.3.5-.4 1.1-.4 1.7v17c0 .2.2.4.4.5h15.8c.1 0 .2 0 .3-.1s.1-.2.1-.3v-17c.2-.6 0-1.2-.3-1.7z"
          fill="#839ca9"
        />
      </g>
    </g>
    <g>
      <defs>
        <path id="prefix__G" d="M151.9 68.1h15v.8h-15z" />
      </defs>
      <clipPath id="prefix__H">
        <use xlinkHref="#prefix__G" overflow="visible" />
      </clipPath>
      <g clipPath="url(#prefix__H)">
        <path
          d="M164.7 68.1h2.2v.8h-2.2m-4.2-.8h2.2v.8h-2.3m-4.2-.8h2.2v.8h-2.2m-4.3-.8h2.2v.8h-2.2"
          fill="#839ca9"
        />
      </g>
    </g>
    <g>
      <defs>
        <path id="prefix__I" d="M24.4 44.1h270v57.7h-270z" />
      </defs>
      <clipPath id="prefix__J">
        <use xlinkHref="#prefix__I" overflow="visible" />
      </clipPath>
      <g clipPath="url(#prefix__J)">
        <text
          transform="translate(223.54 99.62)"
          fill="#839ca9"
          fontFamily="Roboto-Regular"
          fontSize={9}
        >
          {'BODEN'}
        </text>
      </g>
    </g>
    <g>
      <defs>
        <path id="prefix__K" d="M219.4 47.9h37.5v37.5h-37.5z" />
      </defs>
      <clipPath id="prefix__L">
        <use xlinkHref="#prefix__K" overflow="visible" />
      </clipPath>
      <g clipPath="url(#prefix__L)">
        <path
          d="M256.4 66.6c0 .6 0 1.2-.1 1.8-.1.6-.1 1.2-.3 1.8-.1.6-.3 1.2-.4 1.7-.2.6-.4 1.1-.6 1.7-.2.6-.5 1.1-.8 1.6-.6 1.1-1.2 2.1-2 3-.4.5-.8.9-1.2 1.3s-.9.8-1.3 1.2c-.5.4-.9.7-1.4 1.1l-1.5.9c-.5.3-1.1.5-1.6.8s-1.1.4-1.7.6c-.6.2-1.1.3-1.7.4l-1.8.3c-.6.1-1.2.1-1.8.1s-1.2 0-1.8-.1-1.2-.1-1.8-.3c-.6-.1-1.2-.3-1.7-.4-.6-.2-1.1-.4-1.7-.6s-1.1-.5-1.6-.8l-1.5-.9c-.5-.3-1-.7-1.4-1.1s-.9-.8-1.3-1.2c-.4-.4-.8-.9-1.2-1.3-.8-.9-1.4-1.9-2-3-.3-.5-.5-1.1-.8-1.6-.2-.5-.4-1.1-.6-1.7-.2-.6-.3-1.1-.4-1.7l-.3-1.8c-.1-.6-.1-1.2-.1-1.8 0-.6 0-1.2.1-1.8.1-.6.1-1.2.3-1.8.1-.6.3-1.2.4-1.7.2-.6.4-1.1.6-1.7.2-.5.5-1.1.8-1.6.6-1.1 1.2-2.1 2-3 .4-.5.8-.9 1.2-1.3.4-.4.9-.8 1.3-1.2.5-.4.9-.7 1.4-1.1s1-.6 1.5-.9 1.1-.5 1.6-.8c.5-.2 1.1-.4 1.7-.6.6-.2 1.1-.3 1.7-.4l1.8-.3c.6-.1 1.2-.1 1.8-.1s1.2 0 1.8.1l1.8.3c.6.1 1.2.3 1.7.4.6.2 1.1.4 1.7.6.6.2 1.1.5 1.6.8l1.5.9c1 .7 1.9 1.4 2.8 2.3.4.4.8.9 1.2 1.3.8.9 1.4 1.9 2 3 .3.5.5 1.1.8 1.6s.4 1.1.6 1.7c.2.6.3 1.2.4 1.7l.3 1.8c-.1.6 0 1.2 0 1.8z"
          fill="none"
          stroke="#839ca9"
          strokeWidth={1.09}
          strokeMiterlimit={10}
        />
        <path
          d="M233.1 63.1c0-.1.1-.2.1-.2H233.5s.1.1.1.2 0 .1-.1.2H233.2c-.1-.1-.1-.1-.1-.2zm-.8 0c0 .3.1.5.3.7.4.4 1 .4 1.4 0 .2-.2.3-.4.3-.7s-.1-.5-.3-.7-.5-.3-.7-.3c-.3 0-.5.1-.7.3-.2.2-.3.5-.3.7zm2.1-2.3c0-.1.1-.1.2-.1h.1l.1.1c0 .1 0 .2-.1.2h-.2c-.1 0-.1-.1-.1-.2zm.2 1.1c.3 0 .5-.1.7-.3s.3-.5.3-.7c0-.3-.1-.5-.3-.7s-.5-.3-.7-.3c-.3 0-.5.1-.7.3s-.3.4-.3.7.1.5.3.7c.2.2.4.3.7.3zm.7 5l-3 .4-.8-1.4h4.5l-.7 1zm1.5-1.8h-6c-.1 0-.3.1-.4.2-.1.1-.1.3 0 .4l1.3 2.3c.1.1.2.2.4.2l3.5-.5c.1 0 .2-.1.3-.2l1.2-1.8c.1-.1.1-.3 0-.4-.1-.2-.2-.2-.3-.2zm-6.4-1.9c0-.1 0-.2.1-.2h.2c.1.1.1.1 0 .2 0 .1-.1.1-.2.1s-.1 0-.1-.1c-.1 0-.1 0 0 0zm.2 1c.3 0 .5-.1.7-.3s.3-.5.3-.7c0-.3-.1-.5-.3-.7s-.5-.3-.7-.3c-.3 0-.5.1-.7.3s-.3.5-.3.7c0 .5.4.9 1 1zm-.1-5.8c.1-.1.2-.1.2 0 .1 0 .1.1.1.2s-.1.2-.2.2-.2-.1-.2-.2c-.1-.1 0-.2.1-.2zm-1 .2c0 .3.1.5.3.7s.5.3.7.3h.1c.3 0 .5-.1.7-.3.1-.1.2-.2.2-.3.1-.1.1-.3.1-.4 0-.1 0-.3-.1-.4 0-.1-.1-.2-.2-.3-.2-.2-.5-.3-.7-.3-.1 0-.3 0-.4.1-.1 0-.2.1-.3.2-.1.1-.2.2-.2.3-.1.1-.1.3-.2.4zm6.4-.2c.1-.1.2-.1.2 0 .1 0 .1.1.1.2s-.1.2-.2.2-.2-.1-.2-.2 0-.2.1-.2zm-.9.2c0 .1 0 .3.1.4.1.1.1.2.2.3.1.1.2.2.3.2.1.1.3.1.4.1.1 0 .3 0 .4-.1.1-.1.2-.1.3-.2.1-.1.2-.2.2-.3.1-.1.1-.3.1-.4 0-.1 0-.3-.1-.4 0-.1-.1-.2-.2-.3-.1-.1-.2-.2-.3-.2-.1-.1-.3-.1-.4-.1-.1 0-.3 0-.4.1-.1.1-.2.1-.3.2-.1.1-.2.2-.2.3-.1.1-.1.3-.1.4zm.8 4.6c0-.1.1-.2.2-.2s.2.1.2.2 0 .1-.1.2h-.2c-.1-.1-.1-.2-.1-.2zm.2 1c.3 0 .5-.1.7-.3s.3-.5.3-.7-.1-.4-.2-.6c-.1-.2-.3-.3-.5-.4-.2-.1-.4-.1-.6-.1-.2 0-.4.1-.5.3-.1.1-.2.3-.3.5-.1.4.1.8.4 1 .3.2.4.2.7.3zm-4.3-3.4c.1-.1.2-.2.3-.1l.1.1c0 .1-.1.2-.1.2-.1.1-.2.1-.2 0-.1 0-.1-.1-.1-.2zm-.8.1c0 .3.1.5.3.7s.5.3.7.3c.3 0 .5-.1.7-.3s.3-.5.3-.7c0-.4-.2-.7-.5-.8-.3-.2-.8-.2-1.1 0-.3.1-.5.4-.4.8zm-1.9-4.6c0-.1.1-.2.2-.2h.1s.1.1.1.2 0 .1-.1.1c0 0-.1.1-.2.1s-.1 0-.1-.2c0 .1 0 0 0 0zm.2 1c.3 0 .6-.1.8-.3s.3-.5.3-.7c0-.3-.1-.5-.3-.7s-.5-.3-.7-.3c-.3 0-.5.1-.7.3-.1.1-.2.2-.2.3-.1.2-.1.5 0 .8 0 .1.1.2.2.3.1.2.3.3.6.3zm20 19.8h-2.9l-2.4-3.3 1.5-3.7 3.8 3v4zm-3.6-8c-.1-.1-.2-.1-.4-.1-.1 0-.2.1-.3.2l-1.8 4.5c-.1.1-.1.3 0 .4l2.6 3.6c.1.1.2.2.3.2h3.6c.1 0 .2 0 .3-.1s.1-.2.1-.3V73c0-.1 0-.2-.1-.3l-4.3-3.6zm3.6 1.8l-2.7-2.2 2.7-1.9v4.1zm.6-5.3c-.1-.1-.3-.1-.4 0l-3.8 2.7c-.1.1-.2.2-.1.3 0 .2.1.3.3.4l3.7 3c.1.1.2.1.3.1h.2c.1-.1.2-.2.2-.4V66c-.1-.2-.2-.3-.4-.4zm-15 11.5H227v-1.6l3.2-2.6 5.4 1.3-.8 2.9zm1.6-3.5c0-.1-.1-.1-.2-.2l-6-1.5c-.1 0-.3 0-.4.1l-3.5 2.8c-.1.1-.2.2-.2.3v2.3c0 .1 0 .2.1.3.1.1.2.1.3.1h8.6c.2 0 .4-.1.4-.3l.8-3.6c.2-.1.2-.2.1-.3zm-8.8-15c0-.1.1-.2.2-.2s.1 0 .1.1c.1.1.1.2 0 .3H227.6v-.2zm.2 1c.3 0 .5-.1.7-.3s.3-.5.3-.7c0-.3-.1-.5-.3-.7s-.5-.3-.7-.3c-.3 0-.5.1-.7.3-.1.1-.2.2-.2.3s-.1.3-.1.4c0 .1 0 .3.1.4.1.1.1.2.2.3.1.2.4.3.7.3zm-.8 6.2h2.5l1.4 2.4-1.3 2.4L227 69v-3.2zm-.6 3.8l3.1 1.9c.1 0 .1.1.2.1h.1c.1 0 .2-.1.2-.2l1.6-3c.1-.1.1-.3 0-.4l-1.6-2.8c-.1-.1-.2-.2-.4-.2h-3.2c-.1 0-.2 0-.3.1s-.1.2-.1.3v3.8c.1.2.3.4.4.4zm.6 1.4l1.5.9-1.5 1.2V71zm-.6 3.4h.2c.1 0 .2 0 .3-.1l2.6-2.1c.1-.1.2-.2.1-.3 0-.1-.1-.2-.2-.3l-2.6-1.5c-.1-.1-.3-.1-.4 0-.1.1-.2.2-.2.3v3.8c0 .1.1.2.2.2zm8.2-18.3c.1 0 .2.1.2.2s-.1.2-.2.2-.2 0-.2-.1 0-.2.2-.3c-.1 0 0 0 0 0zm0 1.2c.3 0 .6-.1.8-.3s.3-.4.3-.7-.1-.5-.3-.7-.5-.3-.7-.3c-.3 0-.5.1-.7.3s-.3.5-.3.7c0 .3.1.5.3.7.1.2.3.3.6.3zm8.1-1.1c.1 0 .2 0 .2.1s-.1.2-.2.2h-.1c-.1 0-.2 0-.2-.2s.2-.1.3-.1zm0 1.1c.3 0 .5-.1.7-.3s.3-.5.3-.7c0-.3-.1-.5-.3-.7s-.5-.3-.7-.3c-.3 0-.5.1-.7.3-.1.1-.2.2-.2.3-.1.3-.1.5 0 .8.1.4.5.7.9.6zm1.7 5.8c.1.1.2.2.4.2s.3-.1.4-.2c.5-.7 1.3-1.1 2.2-1.2-.6.6-1.2 1.4-1.5 2.2h-2.5c-.4-1.2-1-2.3-1.9-3.2 1.3.2 2.4 1 2.9 2.2zm-1.8 1.6c0 .2.2.3.4.3h3.1c.2 0 .4-.1.4-.3.5-1.1 1.2-2.1 2.1-2.9.1-.1.2-.3.1-.4-.1-.2-.2-.3-.4-.3-1.3-.1-2.6.3-3.5 1.2-.5-.7-1.2-1.3-2-1.7s-1.7-.5-2.6-.4c-.2 0-.3.1-.3.3-.1.2 0 .3.1.4 1.3.9 2.1 2.3 2.6 3.8zm5 1.1l-2.7 1.9-2.8-.5v-1.4h5.5zm-6.3-.6c-.1.1-.1.2-.1.3l.1 2.2c0 .2.1.4.3.4l3.4.6h.1c.1 0 .2 0 .2-.1l3.9-2.8c.2-.1.2-.3.1-.4 0-.2-.2-.3-.4-.3h-7.3c-.1-.1-.2 0-.3.1zm-2.5 5l2.5-1.2 2.6.5-1.5 3.7-4.6-.3 1-2.7zm-1.6 3.3l5.5.4c.2 0 .3-.1.4-.3l1.8-4.4c.1-.1.1-.2 0-.3-.1-.1-.2-.2-.3-.2l-3.2-.6h-.3l-2.8 1.4c-.1 0-.2.1-.2.2l-1.2 3.3c-.1.1-.1.2 0 .4.1.1.2.1.3.1zm-1.2-1l-4.8-1.2 1.3-2.4 3.1-.4 1.5 1.2-1.1 2.8zm1.8-3.1l-1.9-1.5c-.1-.1-.2-.1-.3-.1l-3.5.5c-.1 0-.3.1-.3.2l-1.5 2.9c-.1.2 0 .4.2.5h.1l5.6 1.4h.1c.2 0 .3-.1.4-.3l1.3-3.3s0-.2-.2-.3zm.3-3.5h2.2v1.6l-2.1 1-1.2-1 1.1-1.6zm-1.9 2l.1.1 1.6 1.3c.1.1.3.1.4 0l2.6-1.3c.1-.1.2-.2.2-.4l-.1-2.2c0-.1 0-.2-.1-.3-.1-.1-.2-.1-.3-.1h-2.8c-.1 0-.3.1-.4.2l-1.4 2.1c-.1.1-.1.2-.1.3.2.1.2.2.3.3zm2.4-9.5h.2c.1 0 .1.1.1.2s-.1.2-.2.2-.2 0-.2-.1c-.1-.2 0-.3.1-.3zm0 1.2c.3 0 .5-.1.7-.3.4-.4.4-1 0-1.4l-.2-.2c-.3-.2-.8-.2-1.1 0s-.5.5-.5.8.1.5.3.7c.3.3.5.4.8.4zm8-1.2h.2c.1 0 .1.1.1.2s-.1.2-.2.2-.2 0-.2-.1v-.1c0-.1.1-.2.1-.2.1 0 .1 0 0 0zm0 1.2h.2c.3 0 .5-.1.7-.3s.3-.5.3-.7c0-.5-.5-.9-1-.9-.3 0-.5.1-.7.3s-.3.4-.3.7.1.5.3.7c.1.1.3.2.5.2zm-9.9 17.5l.6-2.7 5.3.4 1.7 2.3h-7.6zm6.5-2.9c-.1-.1-.2-.2-.3-.2l-5.8-.4c-.2 0-.4.1-.4.3l-.9 3.5c0 .1 0 .2.1.3.1.1.2.2.3.2h8.9c.2 0 .3-.1.4-.2.1-.1.1-.3 0-.4l-2.3-3.1z"
          fill="#839ca9"
        />
      </g>
    </g>
    <g>
      <defs>
        <path id="prefix__M" d="M204.4 68.1h15v.8h-15z" />
      </defs>
      <clipPath id="prefix__N">
        <use xlinkHref="#prefix__M" overflow="visible" />
      </clipPath>
      <g clipPath="url(#prefix__N)">
        <path
          d="M217.2 68.1h2.2v.8h-2.2m-4.3-.8h2.2v.8h-2.2m-4.2-.8h2.2v.8h-2.2m-4.2-.8h2.2v.8h-2.3"
          fill="#839ca9"
        />
      </g>
    </g>
    <g>
      <defs>
        <path id="prefix__O" d="M256.9 68.1h37.5v.8h-37.5z" />
      </defs>
      <clipPath id="prefix__P">
        <use xlinkHref="#prefix__O" overflow="visible" />
      </clipPath>
      <g clipPath="url(#prefix__P)">
        <path
          d="M479.7 68.1h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.7-.8h2.2v.8h-2.3m-3.8-.8h2.2v.8h-2.2m-3.7-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8H457m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.3v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.7-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.7-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.7-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.7-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.7-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.7-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.7-.8h2.2v.8h-2.2m-3.8-.8h2.3v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.7-.8h2.2v.8h-2.3m-3.8-.8h2.2v.8h-2.2m-3.7-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8H306m-3.8-.8h2.2v.8h-2.3m-3.7-.8h2.3v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.7-.8h2.2v.8h-2.3m-3.8-.8h2.2v.8h-2.2m-3.7-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8H272m-3.8-.8h2.2v.8h-2.2m-3.7-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.3"
          fill="#839ca9"
        />
      </g>
    </g>
    <g>
      <defs>
        <path id="prefix__Q" d="M13.9-24.1h291v786.8h-291z" />
      </defs>
      <clipPath id="prefix__R">
        <use xlinkHref="#prefix__Q" overflow="visible" />
      </clipPath>
      <g clipPath="url(#prefix__R)" fontFamily="Roboto-Regular">
        <text transform="translate(31.91 159.62)" fill="#71bf44" fontSize={12}>
          {'W'}
        </text>
        <text transform="translate(42.36 159.62)" fill="#71bf44" fontSize={12}>
          {'as planen Sie dieses Jahr (2018-2019) auf'}
        </text>
        <text transform="translate(31.91 173.87)" fill="#71bf44" fontSize={12}>
          {'dem F'}
        </text>
        <text transform="translate(65.03 173.87)" fill="#71bf44" fontSize={12}>
          {'eld anzubauen?'}
        </text>
        <text transform="translate(31.91 197.31)" fill="#839ca9" fontSize={9}>
          {'K'}
        </text>
        <text transform="translate(37.45 197.31)" fill="#839ca9" fontSize={9}>
          {'ultur w\xE4hlen'}
        </text>
        <text transform="translate(31.91 215.87)" opacity={0.87} fontSize={12}>
          {'\xD6'}
        </text>
        <text transform="translate(40.29 215.87)" opacity={0.87} fontSize={12}>
          {'l'}
        </text>
        <text transform="translate(43.33 215.87)" opacity={0.87} fontSize={12}>
          {'k'}
        </text>
        <text transform="translate(49.54 215.87)" opacity={0.87} fontSize={12}>
          {'\xFC'}
        </text>
        <text transform="translate(56.28 215.87)" opacity={0.87} fontSize={12}>
          {'r'}
        </text>
        <text transform="translate(60.47 215.87)" opacity={0.87} fontSize={12}>
          {'b'}
        </text>
        <text transform="translate(67.33 215.87)" opacity={0.87} fontSize={12}>
          {'i'}
        </text>
        <text transform="translate(70.37 215.87)" opacity={0.87} fontSize={12}>
          {'s'}
        </text>
      </g>
    </g>
    <g>
      <defs>
        <path id="prefix__S" d="M268.9 203.9h18v18h-18z" />
      </defs>
      <clipPath id="prefix__T">
        <use xlinkHref="#prefix__S" overflow="visible" />
      </clipPath>
      <g clipPath="url(#prefix__T)">
        <path fill="#839ca9" d="M274.2 211.4l3.7 3.7 3.8-3.7z" />
      </g>
    </g>
    <g>
      <defs>
        <path id="prefix__U" d="M13.9-24.1h291v786.8h-291z" />
      </defs>
      <clipPath id="prefix__V">
        <use xlinkHref="#prefix__U" overflow="visible" />
      </clipPath>
      <g clipPath="url(#prefix__V)">
        <path fill="#839ca9" d="M31.9 223.4h255v.8h-255z" />
        <text
          transform="translate(31.91 220.37)"
          fill="#505f66"
          fontFamily="Roboto-Regular"
          fontSize={12}
        />
        <text
          transform="translate(31.91 247.56)"
          fill="#839ca9"
          fontFamily="Roboto-Regular"
          fontSize={9}
        >
          {'Ihr'}
        </text>
        <text
          transform="translate(42.27 247.56)"
          fill="#839ca9"
          fontFamily="Roboto-Regular"
          fontSize={9}
        >
          {'e Sor'}
        </text>
        <text
          transform="translate(63.01 247.56)"
          fill="#839ca9"
          fontFamily="Roboto-Regular"
          fontSize={9}
        >
          {'te w\xE4hlen'}
        </text>
        <text
          transform="translate(31.91 266.12)"
          opacity={0.87}
          fontFamily="Roboto-Regular"
          fontSize={12}
        >
          {'S'}
        </text>
        <text
          transform="translate(39.16 266.12)"
          opacity={0.87}
          fontFamily="Roboto-Regular"
          fontSize={12}
        >
          {'t'}
        </text>
        <text
          transform="translate(43.2 266.12)"
          opacity={0.87}
          fontFamily="Roboto-Regular"
          fontSize={12}
        >
          {'a'}
        </text>
        <text
          transform="translate(49.86 266.12)"
          opacity={0.87}
          fontFamily="Roboto-Regular"
          fontSize={12}
        >
          {'n'}
        </text>
        <text
          transform="translate(56.61 266.12)"
          opacity={0.87}
          fontFamily="Roboto-Regular"
          fontSize={12}
        >
          {'d'}
        </text>
        <text
          transform="translate(63.51 266.12)"
          opacity={0.87}
          fontFamily="Roboto-Regular"
          fontSize={12}
        >
          {'a'}
        </text>
        <text
          transform="translate(70.16 266.12)"
          opacity={0.87}
          fontFamily="Roboto-Regular"
          fontSize={12}
        >
          {'r'}
        </text>
        <text
          transform="translate(74.24 266.12)"
          opacity={0.87}
          fontFamily="Roboto-Regular"
          fontSize={12}
        >
          {'d'}
        </text>
      </g>
    </g>
    <g>
      <defs>
        <path id="prefix__W" d="M268.9 254.1h18v18h-18z" />
      </defs>
      <clipPath id="prefix__X">
        <use xlinkHref="#prefix__W" overflow="visible" />
      </clipPath>
      <g clipPath="url(#prefix__X)">
        <path fill="#839ca9" d="M274.2 261.6l3.7 3.8 3.8-3.8z" />
      </g>
    </g>
    <g>
      <defs>
        <path id="prefix__Y" d="M13.9-24.1h291v786.8h-291z" />
      </defs>
      <clipPath id="prefix__Z">
        <use xlinkHref="#prefix__Y" overflow="visible" />
      </clipPath>
      <g clipPath="url(#prefix__Z)">
        <path fill="#839ca9" d="M31.9 273.6h255v.8h-255z" />
        <text
          transform="translate(31.91 270.62)"
          fill="#505f66"
          fontFamily="Roboto-Regular"
          fontSize={12}
        />
        <text
          transform="translate(31.91 333.62)"
          fill="#71bf44"
          fontFamily="Roboto-Regular"
          fontSize={12}
        >
          {'W'}
        </text>
        <text
          transform="translate(42.37 333.62)"
          fill="#71bf44"
          fontFamily="Roboto-Regular"
          fontSize={12}
        >
          {'elche Z'}
        </text>
        <text
          transform="translate(80.92 333.62)"
          fill="#71bf44"
          fontFamily="Roboto-Regular"
          fontSize={12}
        >
          {'eit der K'}
        </text>
        <text
          transform="translate(124.63 333.62)"
          fill="#71bf44"
          fontFamily="Roboto-Regular"
          fontSize={12}
        >
          {'ultivierung ?'}
        </text>
        <text
          transform="translate(65.66 368.12)"
          fill="#839ca9"
          fontFamily="Roboto-Regular"
          fontSize={10.5}
        >
          {'2'}
        </text>
        <text
          transform="translate(71.67 368.12)"
          fill="#839ca9"
          fontFamily="Roboto-Regular"
          fontSize={10.5}
        >
          {'0'}
        </text>
        <text
          transform="translate(77.67 368.12)"
          fill="#839ca9"
          fontFamily="Roboto-Regular"
          fontSize={10.5}
        >
          {'1'}
        </text>
        <text
          transform="translate(83.68 368.12)"
          fill="#839ca9"
          fontFamily="Roboto-Regular"
          fontSize={10.5}
        >
          {'8'}
        </text>
        <text
          transform="translate(92.4 368.12)"
          fill="#839ca9"
          fontFamily="Roboto-Regular"
          fontSize={10.5}
        >
          {'-'}
        </text>
        <text
          transform="translate(98.12 368.12)"
          fill="#839ca9"
          fontFamily="Roboto-Regular"
          fontSize={10.5}
        >
          {'2'}
        </text>
        <text
          transform="translate(104.13 368.12)"
          fill="#839ca9"
          fontFamily="Roboto-Regular"
          fontSize={10.5}
        >
          {'0'}
        </text>
        <text
          transform="translate(110.14 368.12)"
          fill="#839ca9"
          fontFamily="Roboto-Regular"
          fontSize={10.5}
        >
          {'1'}
        </text>
        <text
          transform="translate(116.15 368.12)"
          fill="#839ca9"
          fontFamily="Roboto-Regular"
          fontSize={10.5}
        >
          {'9'}
        </text>
        <text
          transform="translate(65.66 405.62)"
          fill="#505f66"
          fontFamily="Roboto-Regular"
          fontSize={10.5}
        >
          {'2'}
        </text>
        <text
          transform="translate(71.67 405.62)"
          fill="#505f66"
          fontFamily="Roboto-Regular"
          fontSize={10.5}
        >
          {'0'}
        </text>
        <text
          transform="translate(77.67 405.62)"
          fill="#505f66"
          fontFamily="Roboto-Regular"
          fontSize={10.5}
        >
          {'1'}
        </text>
        <text
          transform="translate(83.68 405.62)"
          fill="#505f66"
          fontFamily="Roboto-Regular"
          fontSize={10.5}
        >
          {'9'}
        </text>
        <text
          transform="translate(92.4 405.62)"
          fill="#505f66"
          fontFamily="Roboto-Regular"
          fontSize={10.5}
        >
          {'-'}
        </text>
        <text
          transform="translate(98.12 405.62)"
          fill="#505f66"
          fontFamily="Roboto-Regular"
          fontSize={10.5}
        >
          {'2'}
        </text>
        <text
          transform="translate(104.13 405.62)"
          fill="#505f66"
          fontFamily="Roboto-Regular"
          fontSize={10.5}
        >
          {'0'}
        </text>
        <text
          transform="translate(110.14 405.62)"
          fill="#505f66"
          fontFamily="Roboto-Regular"
          fontSize={10.5}
        >
          {'2'}
        </text>
        <text
          transform="translate(116.15 405.62)"
          fill="#505f66"
          fontFamily="Roboto-Regular"
          fontSize={10.5}
        >
          {'0'}
        </text>
        <path
          d="M34.2 364.4c0-.7.1-1.5.2-2.2.1-.7.3-1.4.6-2.1s.6-1.3 1-1.9.8-1.2 1.3-1.7 1-1 1.6-1.4 1.2-.7 1.8-1 1.3-.5 2-.6c1.4-.3 2.7-.3 4.1 0 1.3.3 2.6.8 3.7 1.6.6.4 1.1.9 1.6 1.4s.9 1.1 1.3 1.7c.4.6.7 1.3 1 1.9.3.7.5 1.4.6 2.1s.2 1.5.2 2.2-.1 1.5-.2 2.2c-.1.7-.3 1.4-.6 2.1s-.6 1.3-1 2c-.4.6-.8 1.2-1.3 1.7s-1 1-1.6 1.4-1.2.7-1.8 1-1.3.5-2 .6c-1.4.3-2.7.3-4.1 0-.7-.1-1.4-.4-2-.6-.6-.3-1.2-.6-1.8-1s-1.1-.9-1.6-1.4-.9-1.1-1.3-1.7c-.8-1.2-1.3-2.6-1.6-4.1-.1-.8-.2-1.5-.1-2.2zm-1.5 0c0-2.5.7-5 2-7.1.4-.7.9-1.3 1.5-1.9s1.2-1.1 1.8-1.6c2.6-1.9 5.9-2.6 9-1.9.8.2 1.5.4 2.2.7.7.3 1.4.7 2.1 1.2.7.5 1.3 1 1.8 1.6.6.6 1.1 1.2 1.5 1.9.4.7.8 1.4 1.1 2.2.3.8.5 1.6.7 2.4.3 1.7.3 3.3 0 5-.3 1.6-.9 3.2-1.8 4.6-.4.7-.9 1.3-1.5 1.9-.5.6-1.1 1.1-1.8 1.6-.6.5-1.3.9-2.1 1.2-.7.3-1.5.6-2.2.7-1.5.3-3.1.3-4.7 0-.8-.2-1.5-.4-2.2-.7-.7-.3-1.4-.7-2.1-1.2-.7-.5-1.3-1-1.8-1.6s-1-1.3-1.5-2c-.4-.7-.8-1.4-1.1-2.2-.3-.8-.5-1.6-.7-2.4-.1-.8-.2-1.6-.2-2.4zM34.2 401.9c0-.7.1-1.5.2-2.2.1-.7.3-1.4.6-2.1s.6-1.3 1-1.9.8-1.2 1.3-1.7 1-1 1.6-1.4 1.2-.7 1.8-1 1.3-.5 2-.6c1.4-.3 2.7-.3 4.1 0 1.4.3 2.7.9 3.8 1.7.6.4 1.1.9 1.6 1.4s.9 1.1 1.3 1.7c.4.6.7 1.3 1 1.9.3.7.5 1.4.6 2.1s.2 1.5.2 2.2-.1 1.5-.2 2.2c-.1.7-.3 1.4-.6 2.1s-.6 1.3-1 2c-.4.6-.8 1.2-1.3 1.7s-1 1-1.6 1.4-1.2.7-1.8 1-1.3.5-2 .6c-1.4.3-2.7.3-4.1 0-.7-.1-1.4-.4-2-.6-.6-.3-1.2-.6-1.8-1s-1.1-.9-1.6-1.4-.9-1.1-1.3-1.7c-.8-1.2-1.3-2.6-1.6-4.1-.2-.8-.2-1.6-.2-2.3zm-1.5 0c0-2.5.7-5 2-7.1.4-.7.9-1.3 1.5-1.9s1.2-1.1 1.8-1.6c2.6-1.9 5.9-2.6 9-1.9.8.2 1.5.4 2.2.7.7.3 1.4.7 2.1 1.2.7.5 1.3 1 1.8 1.6.6.6 1.1 1.2 1.5 1.9.4.7.8 1.4 1.1 2.2.3.8.5 1.6.7 2.4.3 1.7.3 3.3 0 5-.3 1.6-.9 3.2-1.8 4.6-.4.7-.9 1.3-1.5 1.9-.5.6-1.2 1.1-1.8 1.6s-1.3.9-2.1 1.2c-.7.3-1.5.6-2.2.7-1.5.3-3.1.3-4.7 0-.8-.2-1.5-.4-2.2-.7-.7-.3-1.4-.7-2.1-1.2-.7-.5-1.3-1-1.8-1.6s-1-1.2-1.5-1.9c-.4-.7-.8-1.4-1.1-2.2-.3-.8-.5-1.6-.7-2.4-.1-.8-.2-1.7-.2-2.5z"
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#839ca9"
        />
        <path
          d="M52.9 401.9c0 .5-.1 1.1-.2 1.6-.2 1.1-.6 2.1-1.2 3-.3.4-.6.9-1 1.2-.4.4-.8.7-1.2 1-.5.3-.9.6-1.4.8-.5.2-1 .4-1.5.5-1.1.2-2.2.2-3.2 0-.5-.1-1-.3-1.5-.5s-1-.5-1.4-.8c-.9-.6-1.7-1.4-2.3-2.3s-1-1.9-1.2-3-.2-2.2 0-3.2c.2-1.1.6-2.1 1.2-3 .3-.5.6-.9 1-1.3s.8-.7 1.2-1 .9-.6 1.4-.8c.5-.2 1-.4 1.5-.5 1.1-.2 2.2-.2 3.2 0 .5.1 1 .3 1.5.5s1 .5 1.4.8.9.6 1.2 1c.4.4.7.8 1 1.3.6.9 1 1.9 1.2 3 .2.6.3 1.1.3 1.7z"
          fill="#71bf44"
        />
        <text
          transform="translate(31.91 470.87)"
          fill="#71bf44"
          fontFamily="Roboto-Regular"
          fontSize={12}
        >
          {'W'}
        </text>
        <text
          transform="translate(42.36 470.87)"
          fill="#71bf44"
          fontFamily="Roboto-Regular"
          fontSize={12}
        >
          {'as ist Ihr Er'}
        </text>
        <text
          transform="translate(102.11 470.87)"
          fill="#71bf44"
          fontFamily="Roboto-Regular"
          fontSize={12}
        >
          {'tr'}
        </text>
        <text
          transform="translate(109.86 470.87)"
          fill="#71bf44"
          fontFamily="Roboto-Regular"
          fontSize={12}
        >
          {'agsziel? (Bitte Eingabe in'}
        </text>
        <text
          transform="translate(31.91 485.12)"
          fill="#71bf44"
          fontFamily="Roboto-Regular"
          fontSize={12}
        >
          {'T'}
        </text>
        <text
          transform="translate(38.49 485.12)"
          fill="#71bf44"
          fontFamily="Roboto-Regular"
          fontSize={12}
        >
          {'onnen/Hektar)'}
        </text>
      </g>
    </g>
    <g>
      <defs>
        <path id="prefix__aa" d="M31.9 503.1h235.5v24H31.9z" />
      </defs>
      <clipPath id="prefix__ab">
        <use xlinkHref="#prefix__aa" overflow="visible" />
      </clipPath>
      <g clipPath="url(#prefix__ab)">
        <text
          transform="translate(31.91 518.87)"
          fill="#505f66"
          fontFamily="Roboto-Regular"
          fontSize={12}
        >
          {'10'}
        </text>
      </g>
    </g>
    <g>
      <defs>
        <path id="prefix__ac" d="M13.9-24.1h291v786.8h-291z" />
      </defs>
      <clipPath id="prefix__ad">
        <use xlinkHref="#prefix__ac" overflow="visible" />
      </clipPath>
      <g clipPath="url(#prefix__ad)">
        <text
          transform="matrix(.9707 0 -.2402 .9707 267.2 518.87)"
          fill="#839ca9"
          fontFamily="Roboto-Regular"
          fontSize={10.812}
        >
          {'t'}
        </text>
        <text
          transform="matrix(.9707 0 -.2402 .9707 270.74 518.87)"
          fill="#839ca9"
          fontFamily="Roboto-Regular"
          fontSize={10.812}
        >
          {'/'}
        </text>
        <text
          transform="matrix(.9707 0 -.2402 .9707 275.18 518.87)"
          fill="#839ca9"
          fontFamily="Roboto-Regular"
          fontSize={10.812}
        >
          {'h'}
        </text>
        <text
          transform="matrix(.9707 0 -.2402 .9707 281.07 518.87)"
          fill="#839ca9"
          fontFamily="Roboto-Regular"
          fontSize={10.812}
        >
          {'a'}
        </text>
        <path fill="#839ca9" d="M31.9 526.4h255v.8h-255z" />
        <text
          transform="translate(31.91 523.37)"
          fill="#505f66"
          fontFamily="Roboto-Regular"
          fontSize={12}
        />
        <text
          transform="translate(31.91 540.62)"
          fill="#839ca9"
          fontFamily="Roboto-Regular"
          fontSize={9}
        >
          {'zwischen 0 - 16 t/ha'}
        </text>
        <text
          transform="translate(31.91 601.37)"
          fill="#71bf44"
          fontFamily="Roboto-Regular"
          fontSize={12}
        >
          {'Wie is der Entwicklungszustand Ihr'}
        </text>
        <text
          transform="translate(217.12 601.37)"
          fill="#71bf44"
          fontFamily="Roboto-Regular"
          fontSize={12}
        >
          {'er K'}
        </text>
        <text
          transform="translate(237.9 601.37)"
          fill="#71bf44"
          fontFamily="Roboto-Regular"
          fontSize={12}
        >
          {'ultur'}
        </text>
        <text
          transform="translate(31.91 615.62)"
          fill="#71bf44"
          fontFamily="Roboto-Regular"
          fontSize={12}
        >
          {'nach dem Winter?'}
        </text>
      </g>
    </g>
  </svg>
);

export default PhoneAT;
